import React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { BoxProps } from '@mui/material/Box';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import RootErrorPage from './RootErrorPage';
import tokens from './tokens.json';
import NotFoundErrorPage from '@/global-pages/NotFoundErrorPage';

export default function RoutingErrorPage(props: {
  cta?: React.ReactNode;
  mainDivProps?: BoxProps;
}) {
  const error = useRouteError();
  const appInsights = useAppInsightsContext();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFoundErrorPage />;
  }

  let description = tokens.TRY_LATER;
  if (isChunkLoadError(error)) {
    description = tokens.OLD_BUILD;
  }

  appInsights?.trackException({
    error: error as Error,
    severityLevel: SeverityLevel.Error,
  });

  return <RootErrorPage title={tokens.UNEXPECTED} description={description} {...props} />;
}

function isChunkLoadError(error: unknown) {
  if (error && typeof error === 'object' && 'message' in error && 'name' in error) {
    const chunkLoadMessage = /Loading chunk [\d]+ failed/;
    const errorMessage = error.message;

    if (error.name === 'ChunkLoadError') {
      if (typeof errorMessage === 'string' && chunkLoadMessage.test(errorMessage)) {
        return true;
      }
    }
  }

  return false;
}
